var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('PageButton',{staticClass:"sign-in-out-button",attrs:{"image-url":_vm.imageUrl('login'),"route-url":"login","icon-title":" ","icon-size":"48"}})
}
var staticRenderFns = []

export { render, staticRenderFns }